import { render } from "./OnDemandBookingReason.vue?vue&type=template&id=15f1d814&scoped=true&ts=true"
import script from "./OnDemandBookingReason.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingReason.vue?vue&type=script&lang=ts"

import "./OnDemandBookingReason.vue?vue&type=style&index=0&id=15f1d814&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f1d814"]])

export default __exports__